import $ from 'jquery'
import Helpers from './Helpers'

export default {
    init: function() {
        let that = this;
        // $('.ml-auto-container').hide();

        // $(document).ready(function () {
            this.refreshSpacingHelpers();

            Helpers.setCurrentTailwindScreen()

            $(window).on('resize', function () {
                that.refreshSpacingHelpers();

                // console.log($('.tw-screen').css('content'))

                // console.log('test')
                const twCurrentScreen = Helpers.getCurrentTailwindScreen()
                // console.log({twCurrentScreen})
            })
        // });
    },
    refreshSpacingHelpers: function() {
        // const containerMarginLeft = parseInt($('.container').css('margin-left'))
        // $('.mx-auto-container').each(function () {
        $('[data-mx-match]').each(function () {
            const id = $(this).data('mx-match')
            const twCurrentScreen = Helpers.getCurrentTailwindScreen()

            const disabledScreensCsv = $(this).data('mx-match-disabled-on') || ''
            const disabledScreens = disabledScreensCsv.split(',')

            if(disabledScreens.includes(twCurrentScreen)) {
                $(this).css({
                    'margin-left': 0,
                    'margin-right': 0,
                })

                return;
            }

            // const isNegative = $(this).data('mx-auto-container') === -1 ? -1 : 1;
            const isNegate = 1;
            // const isNegate = -1;

            const $helper = $(`[data-mx-match-helper="${ id }"]`);

            if($helper.length === 0) return;

            // const newMarginLeft = parseInt($helper.css('margin-left'))
            // const newMarginRight = parseInt($helper.css('margin-right'))
            const newMarginLeft = parseFloat($helper[0].offsetLeft)
            const newMarginRight = $(window).width() - ( parseFloat($helper[0].offsetLeft) + parseFloat($helper[0].offsetWidth) )

            // $(this).show();
            $(this).removeClass('hidden opacity-0');

            // console.log($helper[0].getBoundingClientRect())
            // console.log(newMarginLeft, newMarginRight)

            $(this).css({
                'margin-left': isNegate * parseFloat(newMarginLeft),
                'margin-right': isNegate * parseFloat(newMarginRight),
            })
        });

        // $('[data-width-match]').each(function () {
        //     const id = $(this).data('width-match')
        //
        //     // const isNegative = $(this).data('mx-auto-container') === -1 ? -1 : 1;
        //     // const isNegate = 1;
        //     // const isNegate = -1;
        //
        //     const $helper = $(`[data-width-match-helper="${ id }"]`);
        //
        //     if($helper.length === 0) return;
        //
        //     // const newMarginLeft = parseInt($helper.css('margin-left'))
        //     // const newMarginRight = parseInt($helper.css('margin-right'))
        //     const newWidth = parseFloat($helper.width())
        //
        //     // $(this).show();
        //     $(this).removeClass('hidden opacity-0');
        //
        //     // console.log($helper[0].getBoundingClientRect())
        //     // console.log(newWidth, newMarginRight)
        //
        //     $(this).css({
        //         'width': parseInt(newWidth),
        //     })
        // });

        /**
         * prefer this over `data-full-width`!!
         */
        $('[data-full-width], [data-bg-full-width]').each(function () {
            const $this = $(this);

            if(! $this.is(":visible")) {
                return;
            }

            // mode left - full width from left side screen start
            // mode right - full width to right side screen end
            // mode default - full screen from left to right
            let mode = $this.data('full-width') ? $this.data('full-width') : ''
            mode = $this.data('bg-full-width') ? $this.data('bg-full-width') : mode

            bgFullWidth($this, mode)
        });

        function bgFullWidth($this, mode) {
            if(! $this.is(":visible")) {
                return;
            }

            // mode left - full width from left side screen start
            // mode right - full width to right side screen end
            // mode default - full screen from left to right
            // const mode = $this.data('bg-full-width')

            // first, resetting so that rect can be calculated fresh
            $this.css({
                // 'left': 'auto',
                'left': 0,
                'right': 0,
                'top': 0,
                'bottom': 0,
                'width': 'auto',
            })

            const rect = $this[0].getBoundingClientRect()

            // $this.removeClass('hidden opacity-0');
            $this.removeClass('opacity-0');

            // console.log($this[0].getBoundingClientRect())
            // console.log(newMarginLeft, newMarginRight)


            // TODO major cleanup required


            if(mode === 'left') {
                let newWidth = parseFloat(rect.x) + parseFloat(rect.width)

                $this.css({
                    'left': -1 * parseFloat(rect.x),
                    'width': parseFloat(newWidth),
                })
            } else if(mode === 'right') {
                let remainingRightWidth = $(window).width() - ( parseFloat(rect.x) + parseFloat(rect.width) )
                let newWidth = parseFloat(rect.width) + remainingRightWidth

                $this.css({
                    'width': parseFloat(newWidth),
                })
            } else if(mode === 'full') {
                let newWidth = $(window).width()

                $this.css({
                    'left': -1 * parseFloat(rect.x),
                    'width': parseFloat(newWidth),
                })
            } else {
                $this.css({
                    'left': 0,
                    'right': 0,
                    'top': 0,
                    'bottom': 0,
                })
            }
        }

        // ref https://salferrarello.com/full-screen-width-image-inside-container/
        // .alignfull {
        //     margin-left: calc(50% - 50vw);
        //     margin-right: calc(50% - 50vw);
        //     max-width: 1000%;
        //     width: auto;
        // }

        this.refreshScreenCenterBlocks()
    },
    refreshScreenCenterBlocks: function() {
        /**
         * center any div relative to screen!
         */
        $('.ml-screen-center').each(function () {
            const $this = $(this);

            // first resetting margins so that rect can be calculated fresh
            $(this).css({
                'margin-left': 0, //'auto',
            })

            const rect = $this[0].getBoundingClientRect()
            // console.log(rect);
            // const containerMarginLeft = parseInt($this[0].offsetLeft)
            // const containerMarginRight = $(window).width() - ( parseInt($this[0].offsetLeft) + parseInt($this[0].offsetWidth) )
            let newMarginLeft = ($(window).width() / 2 ) - rect.x

            $(this).removeClass('opacity-0');
            $(this).parent().removeClass('opacity-0');

            // console.log($this[0].getBoundingClientRect())
            // console.log(newMarginLeft, newMarginRight)

            // newMarginLeft = newMarginLeft < 0 ? newMarginLeft : -1 * newMarginLeft;

            $(this).css({
                'margin-left': parseFloat(newMarginLeft),
            })
        });
    }
}
